'use client';

import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useRef } from 'react';
const SIDEBAR_BOTTOM_MARGIN = 16;

/** Viewport-linked height for sticky PLP side columns (filters / AI slot), updated on scroll + resize. */
export function useStickySidebarHeight() {
  const $ = _c(2);
  const ref = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const el = ref.current;
      if (!el) {
        return;
      }
      const update = () => {
        const top = el.getBoundingClientRect().top;
        const h = window.innerHeight - Math.max(top, 0) - SIDEBAR_BOTTOM_MARGIN;
        el.style.height = `${Math.max(h, 200)}px`;
      };
      update();
      window.addEventListener("scroll", update, {
        passive: true
      });
      window.addEventListener("resize", update, {
        passive: true
      });
      const ro = new ResizeObserver(update);
      ro.observe(document.body);
      return () => {
        window.removeEventListener("scroll", update);
        window.removeEventListener("resize", update);
        ro.disconnect();
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useLayoutEffect(t0, t1);
  return ref;
}